/* Native links and details work without JavaScript, including editor reloads. */
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  const openMenu = event.target.closest('.ph-brand details[open]');
  if (!openMenu) return;
  openMenu.open = false;
  openMenu.querySelector('summary').focus();
});
document.addEventListener('click', function (event) {
  document.querySelectorAll('.ph-brand details[open]').forEach(function (menu) {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('shopify:block:select', function (event) {
  const hotspot = event.target.closest('.ph-home__hotspot');
  if (hotspot) hotspot.focus({ preventScroll: true });
});

/* Klickpunkte im Ladenbild --------------------------------------------------
   · Zeiger/Fokus setzt den Scheinwerfer auf die angesteuerte Stelle.
   · Die Beschriftung steht dauerhaft neben jedem Punkt. Frueher war sie
     unsichtbar, und auf dem Telefon oeffnete der erste Tipp nur die Blase,
     erst der zweite den Link — sonst haette man nie gesehen, wohin es geht.
     Das hiess aber auch: wer einmal tippte, sah scheinbar nichts passieren.
     Jetzt steht das Ziel vorher da, und ein Tipp fuehrt direkt hin. */
(function () {
  var scene = document.querySelector('.ph-home__scene');
  if (!scene) return;
  var spots = scene.querySelectorAll('.ph-home__hotspot');
  if (!spots.length) return;
  var coarse = window.matchMedia('(hover: none)').matches;

  function light(el) {
    scene.style.setProperty('--hx', el.style.getPropertyValue('--x') || '50%');
    scene.style.setProperty('--hy', el.style.getPropertyValue('--y') || '50%');
    spots.forEach(function (s) { s.classList.toggle('is-active', s === el); });
    scene.classList.add('is-spotting');
  }
  function dark() {
    scene.classList.remove('is-spotting');
    spots.forEach(function (s) { s.classList.remove('is-active'); });
  }

  spots.forEach(function (el) {
    el.addEventListener('pointerenter', function () { if (!coarse) light(el); });
    el.addEventListener('pointerleave', function () { if (!coarse) dark(); });
    el.addEventListener('focus', function () { light(el); });
    el.addEventListener('blur', dark);
  });

  /* Einmalige Ankunft der Klickpunkte, sobald das Bild im Sichtfeld steht. */
  if (scene && 'IntersectionObserver' in window) {
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        seen.unobserve(e.target);
        e.target.classList.add('is-seen');
      });
    }, { threshold: 0.2 });
    seen.observe(scene);
  } else if (scene) {
    scene.classList.add('is-seen');
  }

  /* WCAG 1.4.13: Was beim Ueberfahren erscheint, muss sich wegdruecken lassen,
     ohne den Zeiger zu bewegen. Escape nimmt die grosse Sprechblase zurueck
     auf die kleine Beschriftung, bis sich der Zeiger das naechste Mal bewegt
     oder der Fokus wechselt. Die kleine Beschriftung selbst bleibt — sie
     erscheint nicht erst beim Ueberfahren, faellt also nicht unter 1.4.13. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    dark();
    if (scene) scene.classList.add('is-tips-off');
    if (document.activeElement && document.activeElement.closest('.ph-home__hotspot')) document.activeElement.blur();
  });
  ['pointermove', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function () {
      if (scene) scene.classList.remove('is-tips-off');
    }, { passive: true });
  });
})();
